<div #modalRef>
  <div tabindex="0" class="focus-anchor" (focus)="startFocus()"></div>
  <div class="modal-header" [class.empty]="!title">
    <div>
      @if (title) {
        <h2 class="modal-title heading-size-4 m-0" [id]="titleId">
          {{ title }}
        </h2>
      }
      @if (subTitle) {
        <p class="sub-title m-0">{{ subTitle }}</p>
      }
    </div>
  </div>
  <div class="modal-body">
    <ng-content></ng-content>
  </div>
  <div
    class="modal-footer"
    [class.empty]="
      !showAltButton &&
      !showSecondaryButton &&
      !showPrimaryButton &&
      !showRemoveButton
    "
  >
    @if (showAltButton) {
      <button
        type="button"
        vinnova-button-text
        class="alt-btn"
        (click)="altButton.emit()"
        [disabled]="isLoading"
      >
        {{ altButtonText }}
      </button>
    }
    @if (showLightButton) {
      <button
        type="button"
        vinnova-button-light
        (click)="lightButton.emit()"
        [disabled]="isLoading"
      >
        {{ lightButtonText }}
      </button>
    }
    @if (showSecondaryButton) {
      <button
        type="button"
        vinnova-button-secondary
        (click)="secondaryButton.emit()"
        [disabled]="disableSecondaryButton || isLoading"
      >
        {{ secondaryButtonText }}
      </button>
    }
    @if (showPrimaryButton) {
      <button
        type="button"
        vinnova-button-primary
        (click)="primaryButton.emit()"
        [disabled]="disablePrimaryButton || isLoading"
      >
        {{ primaryButtonText }}
      </button>
    }
    @if (showRemoveButton) {
      <button
        type="button"
        vinnova-button-remove
        (click)="removeButton.emit()"
        [disabled]="isLoading"
      >
        {{ removeButtonText }}
      </button>
    }
  </div>
  <div class="modal-header bottom" [class.empty]="!title">
    @if (showCloseButton) {
      <button
        vinnova-button-text
        type="button"
        class="close-btn"
        [attr.aria-label]="closeLabel"
        size="icon"
        (click)="closeModal.emit()"
        [disabled]="disableCloseButton || isLoading"
      >
        <lib-icon name="x" aria-hidden="true"></lib-icon>
      </button>
    }
  </div>
  <div tabindex="0" class="focus-anchor" (focus)="endFocus()"></div>
</div>

@if (isLoading) {
  <div class="overlay">
    <div class="overlay-loader">
      <div class="loader"></div>
    </div>
  </div>
}
